import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
axios.defaults.withCredentials = true;

export const money = (n) => new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(n || 0);
export const compact = (n) => {
  n = n || 0;
  if (Math.abs(n) >= 1e12) return `Rp ${(n/1e12).toFixed(1)} T`;
  if (Math.abs(n) >= 1e9) return `Rp ${(n/1e9).toFixed(1)} M`;
  if (Math.abs(n) >= 1e6) return `Rp ${(n/1e6).toFixed(1)} jt`;
  return money(n);
};
export const date = (s) => s ? new Date(s).toLocaleDateString("id-ID", { day:"numeric", month:"short", year:"numeric" }) : "-";
export const dateTime = (s) => s ? new Date(s).toLocaleString("id-ID", { day:"numeric", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit" }) : "-";
export const slug = (s) => String(s || "").toLowerCase().replaceAll(" ", "-");
export const call = {
  get: (p) => axios.get(`${API}${p}`).then(r => r.data),
  post: (p, d) => axios.post(`${API}${p}`, d).then(r => r.data),
  put: (p, d) => axios.put(`${API}${p}`, d).then(r => r.data),
  patch: (p, d) => axios.patch(`${API}${p}`, d).then(r => r.data),
  delete: (p) => axios.delete(`${API}${p}`).then(r => r.data),
  upload: (p, formData) => axios.post(`${API}${p}`, formData, { headers: { "Content-Type": "multipart/form-data" } }).then(r => r.data),
};
export function formatError(e, fallback = "Terjadi kesalahan") {
  const d = e?.response?.data?.detail ?? e?.message;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(x => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}
export const fileUrl = (id) => `${API}/files/${id}`;

export async function streamPost(path, body, onChunk) {
  const res = await fetch(`${API}${path}`, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
  if (!res.ok) { let d = "Gagal"; try { d = (await res.json()).detail || d; } catch (e) {} throw new Error(d); }
  const reader = res.body.getReader(); const dec = new TextDecoder();
  let full = "";
  while (true) { const { done, value } = await reader.read(); if (done) break; full += dec.decode(value, { stream: true }); onChunk(full); }
  return full;
}
